module.exports = __webpack_public_path__ + "static/media/3.08e2bcf2.jpg";